import { Outlet, useParams } from "react-router-dom";
import { AppBarTitle } from "../../../layout/appbar/Title/context";

export default function SavLayout() {

  const params = useParams();

  return (
    <>
      <AppBarTitle title={"Sav " + params.savId} />
      <Outlet />
    </>
  )
}